import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  submitCancelMembership,
  submitCreateSetUpIntent,
  submitGetUserSubscription,
  submitReSubscribeUser,
  submitSubscribeUser,
  submitUpdatePaymentMethod,
} from "../services/subscriptionService";
import {
  ICancelMemberSubscription,
  ISubscription,
  IUpdateSubscriptionPaymentMethod,
} from "../../utility/types/subscriptionType";

export const subscribeUser = createAsyncThunk(
  "subscription/subscribeUser",
  async ({ payload }: { payload: ISubscription }, { rejectWithValue }) => {
    try {
      const response = await submitSubscribeUser(payload);
      return response;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data.message ||
          error.message ||
          "Unknown Error Occurred"
      );
    }
  }
);

export const reSubscribeUser = createAsyncThunk(
  "subscription/reSubscribeUser",
  async ({ payload }: { payload: ISubscription }, { rejectWithValue }) => {
    try {
      const response = await submitReSubscribeUser(payload);
      return response;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data.message ||
          error.message ||
          "Unknown Error Occurred During Re-Subscription"
      );
    }
  }
);

export const getUserSubscription = createAsyncThunk(
  "getUserSubscription",
  async (_, { rejectWithValue }) => {
    try {
      const response = await submitGetUserSubscription();
      return response;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data.message ||
          error.message ||
          "Unknown Error Occurred"
      );
    }
  }
);

export const createSetUpIntent = createAsyncThunk(
  "setUpIntent",
  async (userId: string, { rejectWithValue }) => {
    try {
      const response = await submitCreateSetUpIntent(userId);
      return { response };
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data.message ||
          error.message ||
          "Unknown Error Occurred"
      );
    }
  }
);

export const updatePaymentMethod = createAsyncThunk(
  "updatePaymentMethod",
  async (
    { payload }: { payload: IUpdateSubscriptionPaymentMethod },
    { rejectWithValue }
  ) => {
    try {
      const response = await submitUpdatePaymentMethod(payload);

      return response;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data.message ||
          error.message ||
          "Unknown Error Occurred"
      );
    }
  }
);

export const cancelMembership = createAsyncThunk(
  "cancelMembership",
  async (
    { payload }: { payload: ICancelMemberSubscription },
    { rejectWithValue }
  ) => {
    try {
      const response = await submitCancelMembership(payload);
      return response;
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data.message ||
          error.message ||
          "Unknown Error Occurred"
      );
    }
  }
);
